import { Navigate, type RouteObject } from 'react-router-dom';
import errorRoutes from './errorRoutes';
import assetRoutes from '#/modules/asset/routes';
import findingRoutes from '#/modules/findings/routes';
import showroomRoutes from '#/modules/showroom/routes';
import workOrderRoutes from '#/modules/workOrder/routes';
import expenseRoutes from '#/modules/expense/routes';
import assetPlanRoutes from '#/modules/asset-plan/routes';
import capitalNeedRoutes from '#/modules/capital-need/routes';
import dashboardRoutes from '#/modules/dashboard/routes';
import adminRoutes from '#/modules/admin/routes';
import alertRoutes from '#/modules/alert/routes';
import RootPage from './pages/RootPage';
import { DEV_MODE } from '#/config/consts';

const routes: RouteObject[] = [
  {
    path: 'error',
    children: errorRoutes,
  },
  {
    path: '/',
    element: <RootPage />,
    children: [
      {
        index: true,
        element: <Navigate to="/dashboard" replace />,
      },
      {
        path: 'assets',
        children: assetRoutes,
      },
      {
        path: 'findings',
        children: findingRoutes,
      },
      // Only show the showroom component in development mode
      ...(DEV_MODE === 'true'
        ? [
            {
              path: 'showroom',
              children: showroomRoutes,
            },
          ]
        : []),
      {
        path: 'work-orders',
        children: workOrderRoutes,
      },
      {
        path: 'expenses',
        children: expenseRoutes,
      },
      {
        path: 'asset-plans',
        children: assetPlanRoutes,
      },
      {
        path: 'capital-needs',
        children: capitalNeedRoutes,
      },
      // admin only in admin mode :)
      {
        path: 'admin',
        children: adminRoutes,
      },
      {
        path: 'dashboard',
        children: dashboardRoutes,
      },
      {
        path: 'alerts',
        children: alertRoutes,
      },
      {
        path: '*',
        element: <Navigate to="/dashboard" replace />,
      },
    ],
  },
];

export default routes;
